<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import addzt from '../../../common/ywlxgz/addzt/index.vue';
import ywgz from '../../../common/ywlxgz/ywgz/index.vue';
import mxdj from '@/components/page/DataGovernance/yhs/mxdj/index.vue';
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: 'jzjtgz',
    components: {
        mxdj,
        addzt,//新增账套
        ywgz// 业务规则
    },
    data: function() {
        return {
            tablekey: 0,
            overlength: 0,
            searchdata: getdata().searchdata,
            searchlist: getdata().searchlist,
            filterSearchlist: [],
            outlist: [],
            headData: getdata().headData,
            pagination: getdata().pagination,
            tableData: [{}],
            searchdiag: false,
            ztdiag: false,
            ywgzpg: false,
            formdata: {},
            ywzl: comMapping.$ywzx,
            sfmr: comMapping.$flag,
            ztid: 0,
            ywgzData: {},
            ywzx: "0",
            childrenTitle: "",
            wikiType: "0",
            pageType: "1",
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        geOoverLength(e) {
            this.overlength = e;
        },
        businessRule(e) {
            // 业务规则点击事件
            /*this.ztid = e.id;
            this.ywgzData = e;
            this.ywzx = e.bsType*/
            this.ywgzpg = true;
        },
        basicInfo(e) {
            // 基本信息点击事件
            this.formdata = e;
            this.childrenTitle = "编辑账套基本信息";
            this.wikiType = "1";
            this.ztdiag = true;
        },
        copySetOfBook(e) {
            // 复制账套点击事件
            this.formdata = e;
            this.childrenTitle = "复制账套基本信息";
            this.wikiType = "2";
            this.ztdiag = true;
        },
        createSetOfBook() {
            // 新建账套点击事件
            this.formdata = {};
            this.childrenTitle = "新建账套基本信息";
            this.wikiType = "0";
            this.ztdiag = true;
        },
        setOfBookDelete() {
            // 删除点击事件
        },
        //初始化
        init() {
            this.setOfBookQuery();
        },
        //查询
        setOfBookQuery() {

        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.setOfBookQuery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.setOfBookQuery();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.setOfBookQuery();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
        },
        forback() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.setOfBookQuery();
            this.ywgzpg = false;
        },
        closediag() {
            this.ztdiag = false;
            this.setOfBookQuery();
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
